<template>
  <div class="intro__card">
    <div class="intro__header">

      <p class="intro__subtitle is-uppercase">
        {{ $t("Política de Cookies") }}
      </p>
    </div>

    <div class="intro__body">
      <p
        class="intro__p"
        v-html="$t('A CONSTÁLICA - ELEMENTOS CONSTRUÇÃO METÁLICA, S.A. (adiante, CONSTÁLICA), com sede na Zona Industrial Monte Cavalo, Lt 25, 3670 -273 Vouzela e NIPC 506927563 é uma sociedade que se dedica, entre outras, à comercialização de materiais de construção, sendo a proprietária do domínio www.constalica.com, onde se encontra alojado o seu WEBSITE.')"
      ></p>

      <p
        class="intro__p has-text-centered"
        v-html="
          $t(
            'A CONSTÁLICA ESTÁ EMPENHADA EM PROTEGER A PRIVACIDADE E OS DADOS PESSOAIS DOS SEUS CLIENTES E UTILIZADORES DO WEBSITE, PELO QUE, ELABOROU E ADOTOU A PRESENTE POLÍTICA DE COOKIES. ESTA POLÍTICA ESCLARECE COMO SÃO UTILIZADOS COOKIES, PIXEL TAGS E OUTRAS TECNOLOGIAS SEMELHANTES, PELO QUE, ACONSELHAMOS A SUA LEITURA.'
          )
        "
      ></p>

      <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        1. {{ $t('O QUE SÃO COOKIES?') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('Cookies são pequenos arquivos de informações que ajudam a identificar o seu browser e que podem armazenar informações, por exemplo, configurações e preferências do Utilizador.')}} 
                        </li>
                        <li>
                            {{$t('Com exceção dos cookies especificamente necessários ao desempenho do website, o armazenamento de outros cookies dependerá sempre da aceitação e consentimento do Utilizador, podendo esse consentimento ser retirado a todo o tempo através de ferramentas específicas do browser.')}}
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        2. {{ $t('COMO UTILIZAMOS COOKIES?') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('Utilizamos cookies para apresentar as suas preferências, por exemplo:')}}
                            <ol type="a">
                                <li>{{$t('Os cookies permitem-nos saber se concordou (ou não) com a utilização de cookies no WEBSITE;')}}</li>
                                <li>{{$t('Os cookies permitem-nos que o identifiquemos como um Utilizador recorrente;')}}</li>
                                <li>{{$t('Os cookies permitem-nos recuperar as suas preferências personalizadas quando navega;')}}</li>
                            </ol>
                        </li>
                        <li>
                            {{$t('Os cookies permitem-nos recolher, anonimamente, estatísticas relativamente aos vídeos que visualizou no WEBSITE.')}}
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        3. {{ $t('OS COOKIES DE TERCEIROS') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('Alguns cookies poderão, ainda, ser armazenados por terceiros que não a CONSTÁLICA.')}} 
                        </li>
                        <li>
                            {{$t('Esses terceiros são prestadores de serviços e, embora a CONSTÁLICA realize todos os esforços no sentido de recorrer apenas a prestadores de serviços que forneçam garantias de utilização de medidas técnicas e organizativas adequadas e conformes aos requisitos da legislação relevante em matéria de proteção de dados, o Utilizador entende que a CONSTÁLICA não é responsável pelo conteúdo e exatidão das políticas de privacidade e de cookies destes terceiros.')}}
                        </li>
                        <li> 
                            {{$t('No Ponto 6 encontra uma descrição de todos os cookies utilizados, entre eles, os de terceiros, e, no Ponto 8, encontra uma descrição de todos os pixel tags e outras tecnologias semelhantes utilizados.')}} 
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        4. {{ $t('PARA QUE SERVEM OS COOKIES?') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('A CONSTÁLICA irá armazenar cookies no seu equipamento para personalizar e facilitar ao máximo a navegação, mas também, para a solução de problemas, estatísticas, garantia de qualidade, e para monitorar a segurança do sistema.')}} 
                        </li>
                        <li>
                            {{$t('Poderá, a todo o tempo, eliminar ou bloquear os referidos cookies, sendo que, ao fazê-lo, alguns recursos deste WEBSITE poderão não funcionar como previsto.')}}
                        </li>
                        <li>
                            {{$t('Os cookies não são utilizados para quaisquer finalidades que não as aqui descritas.')}}
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        5. {{ $t('TIPOS DE COOKIES') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('Os cookies no nosso WEBSITE são utilizados para diferentes finalidades, mas, em geral, a sua utilização pode ser dividida nas seguintes categorias:')}} 
                            <ol type="a">
                                <li>{{$t('Cookies Estritamente Necessários: são cookies que são essenciais para provisão do WEBSITE e para todos os serviços solicitados, mas não executam nenhuma função adicional ou secundária.')}} </li>
                                <li>{{$t('Cookies de Desempenho: são aqueles cookies que fornecem informações estatísticas sobre o uso do WEBSITE, ou seja, a análise da web.')}}</li>
                                <li>{{$t('Cookies de Segmentação/Publicidade: são cookies utilizados para criar perfis ou personalizar conteúdos.')}}</li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        6. {{ $t('COOKIES QUE UTILIZAMOS') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('A seguinte tabela explica de que forma são utilizados cookies no presente WEBSITE.')}} 
                        </li>
                    </ol>
                    <!-- <b-table :data="cookieData" :columns="cookieColumns"></b-table> -->
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{$t('Origem/Fornecedor')}}</th>
                                <th>{{$t('Nome')}}</th>
                                <th>{{$t('Descrição/Finalidade')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Constálica</td>
                                <td>user</td>
                                <td>{{$t('Guarda informação do utilizador, o nome e email para ser para ser visualizado no WEBSITE.')}}</td>
                            </tr>
                            <tr>
                                <td>Constálica</td>
                                <td>selectedLang</td>
                                <td>{{$t('Guarda a linguagem selecionada pelo utilizador')}}</td>
                            </tr>
                            <tr>
                                <td>Constálica</td>
                                <td>hasSeenIntro</td>
                                <td>{{$t('Guarda informação se o utilizador já visualizou a mensagem introdutória para que não apareça das próximas vezes')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        7. {{ $t('CONTROLO E GESTÃO DE COOKIES') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('A todo o tempo poderá controlar e/ou eliminar os cookies, nomeadamente, poderá eliminar todos os cookies que já estejam armazenados no seu equipamento, podendo inclusivamente configurar a maioria dos browsers de forma a prevenir o seu armazenamento.')}} 
                        </li>
                        <li>
                            {{$t('Para que consiga efetuar essa gestão, terá, no entanto, que ajustar manualmente algumas preferências de cada vez que visita determinados websites, sem as quais alguns serviços e funcionalidades poderão não funcionar.')}}
                        </li>
                        <li>
                            {{$t('Como garantia adicional poderá, a todo o tempo, desativar os cookies, configurando o seu browser, de acordo com as instruções disponíveis em:')}}
                            <ol type="a">
                                <li>{{$t('Para utilizadores')}} do Google Chrome: <a href="http://support.google.com/chrome/bin/answer.py?hl=en&amp;answer=95647">http://support.google.com/chrome/bin/answer.py?hl=en&amp;answer=95647</a></li>
                                <li>{{$t('Para utilizadores')}} do Internet Explorer: <a href="https://support.microsoft.com/pt-pt/help/17442/windows-internet-explorer-delete-manage-cookies">https://support.microsoft.com/pt-pt/help/17442/windows-internet-explorer-delete-manage-cookies</a></li>
                                <li>{{$t('Para utilizadores')}} do Microsoft Edge: <a href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy">https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy</a></li>
                                <li>{{$t('Para utilizadores')}} do Mozilla Firefox: <a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences</a></li>
                                <li>{{$t('Para utilizadores')}} do Apple Safari: <a href="http://support.apple.com/kb/ph5042">http://support.apple.com/kb/ph5042</a></li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        8. {{ $t('ALTERAÇÕES À POLÍTICA DE COOKIES') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('A CONSTÁLICA reserva-se no direito de reajustar ou alterar a presente Política a qualquer momento, sendo essas alterações publicitadas.')}} 
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        9. {{ $t('OS NOSSOS DETALHES DE CONTACTO') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    <ol>
                        <li> 
                            {{$t('Caso tenha alguma dúvida ou questão relacionada com esta Política, por favor contacte-nos por escrito através do e-mail maxbox@constalica.com .')}} 
                        </li>
                    </ol>
                </div>
            </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" :open="false" aria-id="contentIdForA11y3">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    aria-controls="contentIdForA11y3">
                    <p class="card-header-title">
                        10. {{ $t('ÚLTIMA VERSÃO') }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>

            <div class="card-content">
                <div class="content">
                    12 07, 2021. Vouzela (Portugal)
                </div>
            </div>
        </b-collapse>
        
    </div>
    <b-button
        native-type="button"
        type="is-primary"
        style="float:right"
        @click="$emit('close')"
        >
        {{ $t("Fechar") }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: "CookiePolicyModal",
  data() {return {
  }}
}
</script>


<style lang="scss" scoped>

.intro__card {
  position: relative;
  background-color: #fff;
  color: #000;
  padding: 50px;
  max-width: 944px;
  margin: auto;
}
.intro__header {
  margin-bottom: 2em;
}

.intro__header_logo {
  height: 60px;
}

.intro__title,
.intro__subtitle {
  font-family: $font-family-title;
  font-weight: bold;
  letter-spacing: 0.7px;
  text-transform: uppercase;
}

.intro__title {
  font-size: 38px;
  line-height: 58px;
}

.intro__subtitle {
  font-size: 20px;
  line-height: 30px;
}

.intro__body {
  margin-bottom: 2em;
}

.intro__p {
  margin-bottom: 1em;
}

.intro__list_item:before {
  content: "—";
  margin-right: 0.5em;
}

.intro__footer_logo {
  width: 105px;
}

.intro__lang_select {
  position: absolute;
  bottom: 13px;
  right: 24px;
  display: flex;
}

.intro__lang_option {
  font-family: $font-family-title;
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  letter-spacing: 0.7px;
  text-decoration-line: underline;
  text-transform: uppercase;
  margin-left: 0.5em;
  cursor: pointer;
}

.intro__lang_option.is-active  {
  color: #111;
}
</style>